var map = {
	"./2026/03/29/animacoes/bojack-horseman.md": 7021,
	"./2026/03/29/animacoes/rick-e-morty.md": 3588,
	"./2026/03/29/filmes/a-origem.md": 8446,
	"./2026/03/29/filmes/como-enlouquecer-seu-chefe.md": 9860,
	"./2026/03/29/filmes/genio-indomavel.md": 2143,
	"./2026/03/29/filmes/interestelar.md": 3923,
	"./2026/03/29/filmes/o-poderoso-chefao-parte-ii.md": 3879,
	"./2026/03/29/filmes/o-poderoso-chefao-parte-iii.md": 8532,
	"./2026/03/29/filmes/o-poderoso-chefao.md": 4565,
	"./2026/03/29/filmes/o-silencio-dos-inocentes.md": 6143,
	"./2026/03/29/filmes/sociedade-dos-poetas-mortos.md": 1287,
	"./2026/03/29/series/big-bang-a-teoria.md": 3944,
	"./2026/03/29/series/breaking-bad.md": 2029,
	"./2026/03/29/series/chernobyl.md": 4850,
	"./2026/03/29/series/dexter.md": 9406,
	"./2026/03/29/series/game-of-thrones.md": 6118,
	"./2026/03/29/series/mr-robot-sociedade-hacker.md": 8291,
	"./2026/03/29/series/sherlock.md": 8141,
	"./2026/03/29/series/the-walking-dead.md": 3596,
	"./2026/03/29/series/yellowstone.md": 5329,
	"./2026/03/30/animacoes/the-simpsons.md": 2933,
	"./2026/03/31/assistidos/filmes/eternos.md": 5431,
	"./2026/04/21/quero-ver/filmes/city-hall.md": 7987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6054;